export default {"src":"/_next/static/media/Logomark (3).0ec2f0a1.svg","height":44,"width":44,"blurWidth":0,"blurHeight":0};